import React, { useState } from 'react';
import styled from 'styled-components';
import { Box, Button, Card, Flex, Heading, Text } from 'rebass';
import { Formik, Form } from 'formik';
import { FormField } from '../components/FormField';
import { compose, withApollo } from 'react-apollo';
import { withToastManager } from 'react-toast-notifications/dist/ToastProvider';
import gql from 'graphql-tag';
import { MaskInput } from '../components/async/SharedComponents';
import { Input } from '../components/TextInput';

const Container = styled(Box)`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding-top: 48px;
`;

const MUTATION = gql`
  query getRecommendationSummaryData($athenaId: String!) {
    getRecommendationSummaryData(athenaId: $athenaId) {
      summary
    }
  }
`;

const AdminGetRecommendationSummaryData = (props) => {
  const [otp, setOtp] = useState('');
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    try {
      // Use the Clipboard API to copy the text
      await navigator.clipboard.writeText(otp);
      setIsCopied(true); // Optionally, change state to show feedback (e.g., "Copied!")

      // Optionally reset the copied state after a few seconds
      setTimeout(() => setIsCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy: ', error);
    }
  };

  const handleSubmit = async (values, actions) => {
    setOtp('');
    actions.setSubmitting(true);
    try {
      const res = await props.client.query({
        query: MUTATION,
        variables: {
          athenaId: values.athenaId,
        },
      });

      if (res && res.data && res.data.getRecommendationSummaryData) {
        setOtp(res.data.getRecommendationSummaryData.summary);
        actions.setSubmitting(false);
      } else {
        actions.setSubmitting(false);
        // console.log(re)
        props.toastManager.add('Error generating, please try again', {
          appearance: 'error',
        });
      }

      actions.setSubmitting(false);
      //   toastManager.add('Error submitting intake form', { appearance: 'error' });
    } catch (err) {
      actions.setSubmitting(false);
      props.toastManager.add('Error generating, please try again', {
        appearance: 'error',
      });
    }
  };

  return (
    <Container>
      <Flex m={[3, 5]} flex={1} flexDirection="column" overflowY={'hidden'}>
        <Heading mb={4} mt={[3, 0]} ml={[1, 0]} fontSize={[4, 5]}>
          Generate Recommendation Summary Data
        </Heading>
        <Card mb={4} p={[3, 4]}>
          <Flex flexDirection={'column'} flex={1} alignItems="center">
            <Formik
              initialValues={{ athenaId: '' }}
              onSubmit={(values, actions) => handleSubmit(values, actions)}
              render={({ errors, touched, isValid, isSubmitting, handleChange, handleBlur, values }) => (
                <Form style={{ width: '300px' }}>
                  <Flex flexDirection="column" flex={1}>
                    <Heading mb={4}>Athena ID</Heading>
                  </Flex>
                  <FormField mb={4} error={touched.athenaId && errors.athenaId}>
                    <Input style={{ textAlign: 'center' }} name="athenaId" value={values.athenaId} onChange={handleChange} onBlur={handleBlur} id="input_phone" />
                  </FormField>

                  <Button mt={4} mb={4} variant="primary" width={1 / 2} disabled={!isValid || isSubmitting} type="submit">
                    Generate
                  </Button>
                </Form>
              )}
            />
          </Flex>
        </Card>
        {!!otp && (
          <Flex flexDirection={'column'} justifyContent={'center'} alignItems={'baseline'}>
            <Flex>
              <Text mr={4}>{'Summary generated: '}</Text>

              <button onClick={handleCopy}>{isCopied ? 'Copied!' : 'Copy to Clipboard'}</button>
            </Flex>

            <Text mt={3}>
              <pre
                style={{
                  whiteSpace: 'pre-wrap',
                  textAlign: 'left',
                }}
              >
                {otp}
              </pre>
            </Text>
          </Flex>
        )}
      </Flex>
    </Container>
  );
};

export default compose(
  withApollo,
  withToastManager
)(AdminGetRecommendationSummaryData);
